import { Component, Input, ElementRef, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'iris-dropzone',
  template: `
    <div class="dropzone-container">
      <h5 class="iris-h5 w500">{{title}}</h5>
      <p class="iris-body2 mt-1 mb-4">{{subtitle}}</p>
      <div class="{{ 'progress ' + progressState }}" #progressBar>
        <div class="filenamecontainer">
            <div *ngFor="let file of files">
                <div class="filename">{{file.name}}</div>
                <button color="warn" (click)="deleteFile(file)"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.0003 1.66602C5.39199 1.66602 1.66699 5.39102 1.66699 9.99935C1.66699 14.6077 5.39199 18.3327 10.0003 18.3327C14.6087 18.3327 18.3337 14.6077 18.3337 9.99935C18.3337 5.39102 14.6087 1.66602 10.0003 1.66602ZM14.167 12.991L12.992 14.166L10.0003 11.1744L7.00866 14.166L5.83366 12.991L8.82533 9.99935L5.83366 7.00768L7.00866 5.83268L10.0003 8.82435L12.992 5.83268L14.167 7.00768L11.1753 9.99935L14.167 12.991Z" fill="#718096"/>
                </svg>
                </button>
            </div>
        </div>
      </div>
      <div>
        <div DragDrop class="dropzone" (filesChangeEmiter)="onFileChange($event)">
          <div class="text-wrapper">
            <div class="centered">
              <input type="file" name="file" id="file" (change)="onFileChange($event.target.files)" (click)="resetFileStack($event)">
              <label for="file"><span class="textLink">Choose a file</span> or Drag it here!</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./dropzone.component.scss']
})

// Old CODE
// <div class="dropzone-container">
// <h5 class="w500">{{title}}</h5>
// <p class="subtitle2 mt-1 mb-4">{{subtitle}}</p>
// <div class="progress" #progressBar >

// </div>
// <div>
//   <div DragDrop class="dropzone" (filesChangeEmiter)="onFileChange($event)">
//     <div class="text-wrapper">
//       <div class="centered">
//         <input type="file" name="file" id="file" (change)="onFileChange($event.target.files)" multiple>
//         <label for="file"><span class="textLink">Choose a file</span> or Drag it here!</label>
//       </div>
//     </div>
//   </div>
// </div>
// <hr>
// <div>
//     <h3 mat-subheader>Files</h3>
//     <div *ngFor="let file of files">
//         <div>{{file.name}}</div>
//         <button color="warn" (click)="deleteFile(file)">Delete</button>
//     </div>
// </div>
// </div>



export class DropzoneComponent implements AfterViewInit, OnChanges{
  public files: any[] = [];

  @ViewChild('progressBar', {static: true}) progressBar: ElementRef;
  @Input() src = '';
  @Input() title = '';
  @Input() subtitle = '';
  @Input() backgroundType: 'solid' | 'subtle' = 'solid';
  @Input() size: 'small' | 'medium' | 'large' = 'medium'
  @Input() imgStyles: { [type: string]: string } = {};
  @Input() nameStyles: { [type: string]: string } = {};
  @Input() ProgressPercentage: 0;
  @Input() progressState: 'verify' | 'success' | 'error' = 'verify';

  alt = '';
  bgColors = [
    'red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue',
    'light-blue', 'cyan', 'teal', 'green', 'light-green',
    'lime', 'amber', 'orange', 'deep-orange',
  ];
  colorCssClass = '';

  constructor() {
  }
  ngAfterViewInit(): void {
    this.progressBar.nativeElement.hidden=true;
    //state = verify / success / error
  }
  ngOnChanges(): void {
    this.setProgress(this.ProgressPercentage)
  }

  onFileChange(pFileList: File[]){
    console.log("change called")
    this.files = Object.keys(pFileList).map(key => pFileList[key]);
    this.progressBar.nativeElement.hidden=false;
    // this.setProgressState('verify')
  }
  resetFileStack(event)
  {
    if(this.files.length == 0)
    {
      console.log("set dom data to null")
      event.target.value = null
    }
  }
  deleteFile(f){
    this.files = this.files.filter(function(w){ return w.name != f.name });
    if(this.files.length == 0)
    {
      this.progressBar.nativeElement.hidden=true;
    }
  }
  setProgress(progresspercentage)
  {
      const totalLength = (this.progressBar.nativeElement.offsetWidth * 2) + (this.progressBar.nativeElement.offsetHeight * 2);
      const input = (progresspercentage > 100) ? 100 : progresspercentage;
      const borderLen = (input / 100) * totalLength;
      let backgroundPos;
      if (borderLen <= this.progressBar.nativeElement.offsetWidth) {
        backgroundPos = (-448 + borderLen) + 'px 0px, 448px -100px, 453px 95px, 0px 100px';
      } else if (borderLen <= (this.progressBar.nativeElement.offsetWidth + this.progressBar.nativeElement.offsetHeight)) {
        backgroundPos = '0px 0px, 448px ' + (-100 + (borderLen - this.progressBar.nativeElement.offsetWidth)) + 'px, 453px 95px, 0px 100px';
      } else if (borderLen <= (this.progressBar.nativeElement.offsetWidth * 2 + this.progressBar.nativeElement.offsetHeight)) {
        backgroundPos = '0px 0px, 448px 0px, ' + (448 - (borderLen - this.progressBar.nativeElement.offsetWidth - this.progressBar.nativeElement.offsetHeight)) + 'px 95px, 0px 100px';
      } else {
        backgroundPos = '0px 0px, 448px 0px, 0px 95px, 0px ' + (100 - (borderLen - (this.progressBar.nativeElement.offsetWidth * 2) - this.progressBar.nativeElement.offsetHeight)) + 'px';
      }
      this.progressBar.nativeElement.setAttribute("style",  "background-position : " + backgroundPos);
  }
  // setProgressState(state)
  // {
  //   var nativeclasslist = this.progressBar.nativeElement.classList;
  //   if(nativeclasslist.contains('progresssuccess'))
  //   {
  //     nativeclasslist.remove('progresssuccess')
  //   }
  //   if(nativeclasslist.contains('progressverify'))
  //   {
  //     nativeclasslist.remove('progressverify')
  //   }
  //   if(nativeclasslist.contains('progresserror'))
  //   {
  //     nativeclasslist.remove('progresserror')
  //   }
  //   if(state == 'verify')
  //   {
  //     nativeclasslist.add('progressverify')
  //   }
  //   else if(state == 'success')
  //   {
  //     nativeclasslist.add('progresssuccess')
  //   }
  //   else if(state == 'error')
  //   {
  //     nativeclasslist.add('progresserror')
  //   }
  // }
}
